module.exports = __webpack_public_path__ + "img/qunliao.dc24d081.jpg";